import { useTheme } from '@mui/material/styles';
export var getColors = function () {
    var theme = useTheme();
    return theme.palette;
};
export var getBackgroundImageRandom = function () {
    var images = ['background.jpg'];
    return {
        /*backgroundImage: `url(/${
          images[Math.floor(Math.random() * images.length)]
        })`,*/
        backgroundColor: 'affaire',
        backgroundRepeat: 'no-repeat',
        /*backgroundColor: (t) =>
          t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],*/
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    };
};
export var getBackgroundColor = function (palette, nameColor) {
    if (nameColor === void 0) { nameColor = 'primary'; }
    return {
        backgroundColor: palette[nameColor].main,
        color: palette[nameColor].contrastText,
    };
};
export var classLinkMenu = function (selected, colorSelected) {
    if (selected === void 0) { selected = false; }
    if (colorSelected === void 0) { colorSelected = 'primary'; }
    var theme = useTheme();
    var color = selected ? colorSelected : 'header';
    return {
        color: selected ? theme.palette[color].main : theme.palette[color].main,
    };
};
export var classIconTitle = function (widthSidebard) {
    if (widthSidebard === void 0) { widthSidebard = null; }
    var theme = useTheme();
    var size = 80;
    var style = {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '50%',
        width: "".concat(size, "px"),
        height: "".concat(size, "px"),
        boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.3)',
        display: 'flex',
        padding: '12px',
        position: 'absolute',
        marginTop: "-".concat(size, "px"),
    };
    if (widthSidebard) {
        style.left = "".concat((widthSidebard - size) / 2, "px");
        style.marginTop = "".concat(size / 2 + 10, "px");
    }
    return style;
};
export var colorEtatClient = function (etat) {
    var color = 'info';
    switch (etat) {
        case 'P':
            color = 'secondary';
            break;
        case 'C':
            color = 'success';
            break;
        default:
            break;
    }
    return color;
};
export var colorEtatActivite = function (etat) {
    var color = 'info';
    switch (etat) {
        case 'A':
            color = 'error';
            break;
        case 'C':
            color = 'success';
            break;
        default:
            break;
    }
    return color;
};
export var colorEtatAffaire = function (etat) {
    var color = 'info';
    switch (etat) {
        case 'E':
            color = 'secondary';
            break;
        case 'A':
        case 'P':
            color = 'error';
            break;
        case 'C':
            color = 'success';
            break;
        default:
            break;
    }
    return color;
};
export var getColor = function (palette, color) {
    if (color === void 0) { color = 'primary'; }
    return palette[color].main;
};
export var classImportDocument = function (palette) {
    return {
        borderStyle: 'dashed',
        borderColor: palette.primary.main,
    };
};
export var classTotal = function (color) {
    return {
        color: color.main,
        borderColor: color.main,
        borderStyle: 'solid',
        borderRadius: '2rem',
        fontWeight: 'bold',
        textAlign: 'center',
        paddingLeft: '5px',
        paddingRight: '5px',
    };
};
export var classChipInHeader = function () {
    return {
        fontWeight: 'bold',
    };
};
//# sourceMappingURL=Classes.js.map